import { lazy } from "react";
import { IRouteDefinition, ISubModuleRoutes } from "../routing";


const FrontPage = lazy(() => import(/* webpackChunkName: 'FrontPage' */"./tyoluvat/views/FrontPage"));
const PermitPageRouter = lazy(() => import(/* webpackChunkName: 'PermitPageRouter' */"./tyoluvat/views/PermitPage/PermitPage"));
const PermitsListPage = lazy(() => import(/* webpackChunkName: 'PermitsListPage' */"./tyoluvat/views/PermitsListPage"))
const PermitArchivePage = lazy(() => import(/* webpackChunkName: 'PermitArchivePage' */"./tyoluvat/views/PermitArchivePage"))

const MapPage = lazy(() => import(/* webpackChunkName: 'PermitMapPage' */"./tyoluvat/views/MapPage"))
const EditPermitPage = lazy(() => import(/* webpackChunkName: 'EditPermitPage' */"./tyoluvat/views/EditPermitPage"))
const InitializePermitPage = lazy(() => import(/* webpackChunkName: 'InitializePermitPage' */"./tyoluvat/views/InitializePermitPage"))
const CopyPermitPage = lazy(() => import(/* webpackChunkName: 'CopyPermitPage' */"./tyoluvat/views/CopyPermitPage"))
const NewPermitPage = lazy(() => import(/* webpackChunkName: 'NewPermitPage' */"./tyoluvat/views/NewPermitPage"))

const PermitCreatedPage = lazy(() => import(/* webpackChunkName: 'PermitCreatedPage' */"./tyoluvat/views/PermitCreatedPage"))
const PermitPrintPage = lazy(() => import(/* webpackChunkName: 'PermitPrintPage' */"./tyoluvat/views/PermitPrintPage"))
const AnonymousPermitPage = lazy(() => import(/* webpackChunkName: 'AnonymousPermitPage' */"./tyoluvat/views/AnonymousPermitPage"))
const AnonymousPermitApprovalPage = lazy(() => import(/* webpackChunkName: 'AnonymousPermitApprovalPage' */"./tyoluvat/views/AnonymousPermitApprovalPage"))





export enum TyoluvatRouteId {
    TyoluvatFrontPage = "tyoluvat-front-page",
    PermitsListPage = "tyoluvat-permit-list-page",
    PermitMapPage = "tyoluvat-permit-map-page",
    PermitArchivePage = "tyoluvat-permit-archive-page",
    InitializePermitPage = "tyoluvat-open-permit-form-page",
    NewPermitPage = "tyoluvat-new-permit-page",

    PermitPage = "tyoluvat-permit-page",
    PermitHistoryPage = "tyoluvat-permit-history-page",
    PermitTasksPage = "tyoluvat-permit-tasks-page",
    PermitEventLog = "tyoluvat-permit-event-log-page",
    PermitEventPage = "tyoluvat-permit-event-page",
    PermitStatusChangePage = "tyoluvat-permit-status-change-page",
    PermitTaskPage = "tyoluvat-permit-task-detail-page",
    PermitTaskFormPage = "tyoluvat-permit-task-form-page",
    PermitManualControl = "tyoluvat-permit-task-manual-control",


    PermitCreatedPage = "tyoluvat-permit-created-page",
    CopyPermitPage = "tyoluvat-permit-copy-page",
    PermitPrint = "tyoluvat-permit-print-page",
    AnonymousPermit = "tyoluvat-anonymous-permit-page",
    AnonymousPermitApproval = "tyoluvat-anonymous-permit-approval-page",
    EditPermitPage = "tyoluvat-edit-permit-page",
    TyoluvatPageNotFoundPage = "tyoluvat-page-not-found"

};



export const tyoluvatRoutes: IRouteDefinition[] = [
    {
        id: TyoluvatRouteId.TyoluvatFrontPage,
        exact: true,
        path: "/",
        component: FrontPage
    },

    {
        id: TyoluvatRouteId.PermitsListPage,
        exact: true,
        path: "/luvat",
        component: PermitsListPage
    },

    {
        id: TyoluvatRouteId.PermitArchivePage,
        exact: true,
        path: "/arkisto",
        component: PermitArchivePage
    },

    {
        id: TyoluvatRouteId.PermitMapPage,
        exact: true,
        path: "/kartta",
        component: MapPage
    },

    {
        id: TyoluvatRouteId.PermitPage,
        exact: true,
        path: "/luvat/:permit/tiedot",
        component: PermitPageRouter
    },

    {
        id: TyoluvatRouteId.PermitEventLog,
        exact: true,
        path: "/luvat/:permit/tapahtumat",
        component: PermitPageRouter
    },

    {
        id: TyoluvatRouteId.PermitEventPage,
        exact: true,
        path: "/luvat/:permit/tapahtumat/:event",
        component: PermitPageRouter
    },

    {
        id: TyoluvatRouteId.PermitStatusChangePage,
        exact: true,
        path: "/luvat/:permit/tilanvaihto",
        component: PermitPageRouter
    },

    {
        id: TyoluvatRouteId.PermitTaskPage,
        exact: true,
        path: "/luvat/:permit/tehtavat/:task/tiedot",
        component: PermitPageRouter
    },

    {
        id: TyoluvatRouteId.PermitTaskFormPage,
        exact: true,
        path: "/luvat/:permit/tehtavat/:task/lomake",
        component: PermitPageRouter
    },

    {
        id: TyoluvatRouteId.PermitTasksPage,
        exact: false,
        path: "/luvat/:permit/tehtavat",
        component: PermitPageRouter
    },


    {
        id: TyoluvatRouteId.EditPermitPage,
        exact: true,
        path: "/muokkaa/permit_:permit",
        component: EditPermitPage
    },


    {
        id: TyoluvatRouteId.InitializePermitPage,
        exact: true,
        path: "/uusi-lupa/:formType",
        component: InitializePermitPage
    },


    {
        id: TyoluvatRouteId.CopyPermitPage,
        exact: true,
        path: "/uusi-lupa/:formType/:basePermit",
        component: CopyPermitPage
    },


    {
        id: TyoluvatRouteId.NewPermitPage,
        exact: true,
        path: "/lupalomake/:formType",
        component: NewPermitPage
    },



    {
        id: TyoluvatRouteId.PermitCreatedPage,
        exact: true,
        path: "/valmis/:formType/:permit",
        component: PermitCreatedPage
    },


    //
    //  Anonymous routes
    //

    {
        id: TyoluvatRouteId.PermitPrint,
        requireAuth: false,
        exact: true,
        path: "/tulosta/lupa/:package",
        component: PermitPrintPage
    },

    {
        id: TyoluvatRouteId.AnonymousPermit,
        requireAuth: false,
        exact: true,
        path: "/anonyymi/lupa/:package",
        component: AnonymousPermitPage
    },

    {
        id: TyoluvatRouteId.AnonymousPermit,
        requireAuth: false,
        exact: true,
        path: "/anonyymi/kuittaus/:package/:approvalGuid",
        component: AnonymousPermitApprovalPage
    },

    {
        id: TyoluvatRouteId.TyoluvatPageNotFoundPage,
        exact: false,
        requireAuth: false,
        path: "",
        component: lazy(() => import(/* webpackChunkName: 'LoginExpiredPage' */"../@common/views/PageNotFoundPage"))
    }

]




const TyoluvatRouting: ISubModuleRoutes = {
    prefix: "tyoluvat",
    routes: tyoluvatRoutes,
    template: lazy(() => import(/* webpackChunkName: 'TyoluvatApp' */"./TyoluvatApp")),
    routeId: TyoluvatRouteId
}

export default TyoluvatRouting